import { graphql } from "gql";

const INTERNAL_ADMIN_TAG_CATEGORY_LIST_QUERY = graphql(`
  query InternalAdminTagCategoryList(
    $organizationId: ID!
    $input: InternalAdminTagCategoryListInput!
  ) {
    internalAdminTagCategoryList(
      organizationId: $organizationId
      input: $input
    ) {
      ...InternalAdminTagCategory
    }
  }
`);

export default INTERNAL_ADMIN_TAG_CATEGORY_LIST_QUERY;
